var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('router-link',{attrs:{"to":{ name: 'single-topic', params: { name: _vm.tag } }},nativeOn:{"click":function($event){return _vm.trackTagClicked({
      tag: _vm.tag,
      source: 'resource'
    })}}},[_vm._v("#"+_vm._s(_vm._f("asTag")(_vm.tag)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }